import type { EmailField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'

export const Email: React.FC<
  EmailField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
  }
> = ({ name, defaultValue, errors, label, register, required, width }) => {
  const placeholder = required ? `${label} *` : label

  return (
    <Width width={width}>
      <Label className="sr-only" htmlFor={name}>
        {label}
        {required && <span className="sr-only"> (required)</span>}
      </Label>
      <Input
        autoComplete="email"
        defaultValue={defaultValue}
        id={name}
        placeholder={placeholder}
        type="email"
        {...register(name, { pattern: /^\S[^\s@]*@\S+$/, required })}
      />

      {errors[name] && <Error name={name} />}
    </Width>
  )
}
